import { LinearProgress, Tooltip } from "@evergis/ui";
import { uniqBy } from "lodash";
import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ResourcesTooltip } from "../../../../components/Dialogs/DeleteLayer/ResourcesTooltip";
import { getLoaderState } from "../../../../ducks/loader/selectors";
import { useProjectLayerNames } from "../../../../hooks/project/useProjectLayers";
import { LoaderWrapper } from "./styled";

export const LayersLoader: FC = () => {
  const { t } = useTranslation("layerList");
  const { layers } = useSelector(getLoaderState);
  const projectLayerNames = useProjectLayerNames();

  const projectLoadingLayers = useMemo(() => {
    return uniqBy(layers, "name")
      .filter(({ name }) => projectLayerNames.includes(name))
      .map(({ alias, name }) => alias || name);
  }, [layers, projectLayerNames]);

  const tooltipContent = useMemo(
    () => <ResourcesTooltip myLabel={t("layerListTitle")} resources={projectLoadingLayers} />,
    [projectLoadingLayers, t],
  );

  return projectLoadingLayers.length > 0 ? (
    <Tooltip content={tooltipContent} placement="bottom" arrow delay={0.5}>
      {ref => (
        <LoaderWrapper ref={ref}>
          <LinearProgress />
        </LoaderWrapper>
      )}
    </Tooltip>
  ) : null;
};
